import React, { createContext, useContext, useEffect, useState } from 'react';
import { echo } from '../echo';
import { useAuth } from './auth';

type PresenceUser = {
  id: string;
  name: string | null;
  employeeId: string | null;
  role: string;
};

type PresenceContextValue = {
  onlineUsers: PresenceUser[];
};

const PresenceContext = createContext<PresenceContextValue>({ onlineUsers: [] });

export function PresenceProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const [onlineUsers, setOnlineUsers] = useState<PresenceUser[]>([]);

  useEffect(() => {
    if (!echo || !user) {
      setOnlineUsers([]);
      return;
    }

    echo
      .join('presence-employees')
      .here((users: PresenceUser[]) => {
        setOnlineUsers(users);
      })
      .joining((joiningUser: PresenceUser) => {
        setOnlineUsers((prev) => {
          if (prev.some((u) => u.id === joiningUser.id)) return prev;
          return [...prev, joiningUser];
        });
      })
      .leaving((leavingUser: PresenceUser) => {
        setOnlineUsers((prev) => prev.filter((u) => u.id !== leavingUser.id));
      });

    return () => {
      if (echo) {
        echo.leave('presence-employees');
      }
      setOnlineUsers([]);
    };
  }, [user]);

  return (
    <PresenceContext.Provider value={{ onlineUsers }}>
      {children}
    </PresenceContext.Provider>
  );
}

export function usePresence() {
  return useContext(PresenceContext);
}

